/**
 * Ported from the-answer-2 (BACKLOG §16: lift the components, not the app).
 * Behaviour is theirs; the edges are savvy's. Changes made on the way in:
 *   - the field's identity is a stable string `id`, not a client-assigned
 *     `callTypeFormFieldId` number sitting beside an unrelated `id`;
 *   - a section is a flat `group` name, not a nested object with its own id;
 *   - drafts, feature announcements, router state and toasts are dropped —
 *     they belong to the host app, not the component.
 */

import { cn } from "@/lib/utils";
import React from "react";

export function FormFieldNote({ note }: { note?: string }) {
  return (
    <div
      className={cn(
        "bg-amber-100 p-3 rounded-sm max-w-[90%] shadow-md relative",
        // "transform rotate-[-1deg]",
        "border-t-[1px] border-amber-200",
        // "after:content-[''] after:absolute after:top-0 after:left-0",
        // "after:border-t-[18px] after:border-r-[18px]",
        "after:border-t-amber-200 after:border-r-transparent",
        "after:rounded-bl-sm"
      )}
    >
      <p className="text-sm text-amber-900 font-medium font-handwriting">
        {note &&
          note.split("\n").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
      </p>
    </div>
  );
}
